import(/* webpackMode: "eager" */ "/codebuild/output/src4526385/src/dharmayana-website/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4526385/src/dharmayana-website/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4526385/src/dharmayana-website/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4526385/src/dharmayana-website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4526385/src/dharmayana-website/src/app/globals.css");
